import React, { useState } from "react";

import {
  CalendarDateRange,
  CalendarPicker,
  SearchableDropdown,
  SearchableDropdownItem,
} from "@fronterahealth/frontera-ui-components";

import { useAdminData } from "@providers/AdminDataProvider";
import { useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

interface DialogFilterBarProps {
  dates: CalendarDateRange | undefined;
  setDates: React.Dispatch<React.SetStateAction<CalendarDateRange | undefined>>;
  selectedBCBA?: SearchableDropdownItem[];
  setSelectedBCBA?: React.Dispatch<React.SetStateAction<SearchableDropdownItem[]>>;
  selectedRBTs?: SearchableDropdownItem[];
  setSelectedRBTs?: React.Dispatch<React.SetStateAction<SearchableDropdownItem[]>>;
  selectedClients?: SearchableDropdownItem[];
  setSelectedClients?: React.Dispatch<React.SetStateAction<SearchableDropdownItem[]>>;
  showBCBAFilter?: boolean;
  showRBTFilter?: boolean;
  showClientFilter?: boolean;
}

export const DialogFilterBar: React.FC<DialogFilterBarProps> = ({
  dates,
  setDates,
  selectedBCBA,
  setSelectedBCBA,
  selectedRBTs,
  setSelectedRBTs,
  selectedClients,
  setSelectedClients,
  showBCBAFilter = true,
  showClientFilter = true,
  showRBTFilter = true,
}) => {
  const { isUserBCBA } = useAdminData();
  const { allBCBAList, isAllBCBAFetching, sessionClients, isSessionClientsLoading, isAllRBTFetching, allRBTList } =
    useVideoAnalytics();

  const [recentSearchesForBCBA, setRecentSearchesForBCBA] = useState<SearchableDropdownItem[]>([]);
  const [recentSearchesForClient, setRecentSearchesForClient] = useState<SearchableDropdownItem[]>([]);
  const [recentSearchesForRBT, setRecentSearchesForRBT] = useState<SearchableDropdownItem[]>([]);

  const handleDateChange = (newDates: CalendarDateRange) => {
    setDates(newDates);
  };
  const handleRecentSearchAddForBCBA = (item: SearchableDropdownItem) => {
    setRecentSearchesForBCBA((prev) => [...prev, item].slice(-5)); // Keep the last 5 searches
  };
  const handleRecentSearchAddForClient = (item: SearchableDropdownItem) => {
    setRecentSearchesForClient((prev) => [...prev, item].slice(-5)); // Keep the last 5 searches
  };
  const handleRecentSearchAddForRBT = (item: SearchableDropdownItem) => {
    setRecentSearchesForRBT((prev) => [...prev, item].slice(-5)); // Keep the last 5 searches
  };

  return (
    <div className="flex flex-row items-center gap-2 justify-start">
      <CalendarPicker
        placeholder="Date"
        selectedDateRange={dates}
        inputSize="sm"
        onDateChange={handleDateChange}
        mode="filter"
        selectedLabel={dates ? dates?.selectedLabel : "Last 7 Days"}
      />
      {showBCBAFilter && !isUserBCBA && setSelectedBCBA ? (
        <SearchableDropdown
          items={allBCBAList}
          label="BCBAs"
          placeholder="All BCBA"
          onSelectionChange={(items: SearchableDropdownItem[]) => {
            setSelectedBCBA(items);
          }}
          recentSearches={recentSearchesForBCBA}
          onRecentSearchAdd={handleRecentSearchAddForBCBA}
          isLoading={isAllBCBAFetching}
          selectedItems={selectedBCBA}
          disabled={isAllBCBAFetching}
        />
      ) : null}
      {showRBTFilter && setSelectedRBTs ? (
        <SearchableDropdown
          items={allRBTList}
          label="RBTs"
          placeholder="All RBTs"
          onSelectionChange={(items: SearchableDropdownItem[]) => {
            setSelectedRBTs(items);
          }}
          recentSearches={recentSearchesForRBT}
          onRecentSearchAdd={handleRecentSearchAddForRBT}
          isLoading={isAllRBTFetching}
          selectedItems={selectedRBTs}
          disabled={isAllRBTFetching}
        />
      ) : null}

      {showClientFilter && setSelectedClients ? (
        <SearchableDropdown
          items={sessionClients}
          label="Client"
          placeholder="Clients"
          onSelectionChange={(items: SearchableDropdownItem[]) => {
            setSelectedClients(items);
          }}
          recentSearches={recentSearchesForClient}
          onRecentSearchAdd={handleRecentSearchAddForClient}
          isLoading={isSessionClientsLoading}
          selectedItems={selectedClients}
          disabled={isSessionClientsLoading}
        />
      ) : null}
    </div>
  );
};
